import React from 'react';
import {priority} from '@priority-software/priority-proto-api/lib';
import {ToDoItemBasicInfo} from './ToDoItemBasicInfo';
import {FieldValue} from './FieldValue';
import {StatusField} from './StatusField';
import {PriorityInput} from './PriorityInput';
import {ListItemBtns} from './ListItemBtns';
import styles from '../../styles/ToDoListConent.module.scss';
import {STATUS_FIELD, PRIORITY_FIELD, TODOLIST} from '../../consts';
import {getFieldValue, MandatoryColIds} from '../../utils';
import {Record} from '../../../../stores/Form/Record';
import {TooltipPosition} from '../../../../components/Common/Tooltip/types';

type ListItemFunctions = {
    record: Record;
    tooltipPosition: TooltipPosition;
    getStatusList: (record: Record) => Promise<priority.netitems.form.ISelectValues[]>;
    saveUpdate: () => void;
    setIsScrollbarDisabled: (value: boolean) => void;
    updateTaskStatus: (value: string) => void;
    updatePriorityField: (record: Record, value: string) => void;
};

interface ListItemProps extends ListItemFunctions {
    mandatoryColIds: MandatoryColIds;
    viewCols: priority.netitems.form.IColumn[];
}

interface ListItemData extends ListItemFunctions {
    col: priority.netitems.form.IColumn;

    itemNumber: string;
}

const renderListItemData = ({
    col,
    itemNumber,
    record,
    getStatusList,
    saveUpdate,
    setIsScrollbarDisabled,
    updateTaskStatus,
    updatePriorityField,
    tooltipPosition
}: ListItemData) => {
    const key = `${col.Name}-${itemNumber}`;
    if (col.Name === STATUS_FIELD) {
        return (
            <StatusField
                key={key}
                column={col}
                record={record}
                getStatusList={getStatusList}
                updateTaskStatus={updateTaskStatus}
                saveUpdate={saveUpdate}
                setIsScrollbarDisabled={setIsScrollbarDisabled}
            />
        );
    } else if (col.Name === PRIORITY_FIELD) {
        return (
            <PriorityInput
                key={key}
                column={col}
                record={record}
                updatePriorityField={updatePriorityField}
            />
        );
    } else {
        return (
            <FieldValue key={key} record={record} column={col} tooltipPosition={tooltipPosition} />
        );
    }
};

export const ListItem = ({
    record,
    mandatoryColIds,
    viewCols,
    getStatusList,
    saveUpdate,
    setIsScrollbarDisabled,
    updateTaskStatus,
    updatePriorityField,
    tooltipPosition
}: ListItemProps) => {
    const itemNumber = getFieldValue(record, mandatoryColIds[TODOLIST])?.toString();
    return (
        <div className={styles.rowData}>
            <ToDoItemBasicInfo
                record={record}
                mandatoryColIds={mandatoryColIds}
                tooltipPosition={tooltipPosition}
            />
            {viewCols.map(col =>
                renderListItemData({
                    col,
                    record,
                    itemNumber,
                    getStatusList,
                    saveUpdate,
                    setIsScrollbarDisabled,
                    updateTaskStatus,
                    updatePriorityField,
                    tooltipPosition
                })
            )}
            <ListItemBtns value={itemNumber} />
        </div>
    );
};
